import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { supabase } from '../lib/supabase';
import { getLocalDateString } from '../lib/dates';

function Dashboard() {
  const [todayJobCount, setTodayJobCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const today = new Date();
  const formattedDate = today.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  const dateString = getLocalDateString(today);

  useEffect(() => {
    let mounted = true;
    const fetchTodayJobs = async () => {
      const { count, error } = await supabase
        .from('jobs')
        .select('id', { count: 'exact', head: true })
        .eq('scheduled_date', dateString)
        .eq('is_deleted', false);

      if (!mounted) return;
      if (!error) setTodayJobCount(count || 0);
      setLoading(false);
    };

    fetchTodayJobs();
    return () => { mounted = false; };
  }, [dateString]);

  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />
      <main className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-brand-black">Dashboard</h1>
          <p className="text-lg text-gray-600 mt-1">{formattedDate}</p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6 mb-8 border-t-4 border-brand-coral">
          <div className="text-center">
            <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">
              Jobs Scheduled Today
            </p>
            {loading ? (
              <p className="mt-2 text-4xl font-bold text-gray-400">...</p>
            ) : (
              <p className="mt-2 text-4xl font-bold text-brand-coral">{todayJobCount}</p>
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Link
            to="/jobs/new"
            className="bg-brand-coral text-white rounded-lg shadow-md p-6 text-center hover:bg-brand-coral-dark transition-colors"
          >
            <svg
              className="w-8 h-8 mx-auto mb-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 4v16m8-8H4"
              />
            </svg>
            <span className="text-lg font-medium">Add Job</span>
          </Link>

          <Link
            to="/schedule"
            className="bg-white text-brand-black rounded-lg shadow-md p-6 text-center hover:bg-gray-50 transition-colors border border-gray-200"
          >
            <svg
              className="w-8 h-8 mx-auto mb-2 text-brand-gray-medium"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span className="text-lg font-medium">View Schedule</span>
          </Link>

          <Link
            to={`/print/${dateString}`}
            className="bg-brand-black text-white rounded-lg shadow-md p-6 text-center hover:bg-brand-gray-dark transition-colors"
          >
            <svg
              className="w-8 h-8 mx-auto mb-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
              />
            </svg>
            <span className="text-lg font-medium">Print Today</span>
          </Link>
        </div>
      </main>
    </div>
  );
}

export default Dashboard;
